import { Task } from "~/packages/taskrouter";
import { ErrorCode, ErrorSeverity, FlexSdkError } from "~/modules/error";
import { getLogger, LoggerName } from "~/modules/logger";
import { TaskRouterImpl } from "~/packages/taskrouter/TaskRouterImpl";
import { CbmImpl } from "~/modules/cbm";
import { ContextInstance, ContextManager } from "~/modules/contextManager/ContextManager";
import { getReservationsByTask, sendTrackingEvent } from "../../ActionUtils";
import { EVENTS } from "~/modules/analytics/Analytics";
import { AnalyticsImpl } from "~/modules/analytics/AnalyticsImpl";
import { Action } from "~/modules/actions/Action";




















export class CompleteTask implements Action<Promise<Task>> {
    


    #taskSid: string;

    constructor(taskSid: string) {
        this.#taskSid = taskSid;
    }

    async run(ctx: {}) {
        const context = ctx as ContextManager;
        const taskRouter = context.retrieveInstanceOf(ContextInstance.TaskRouter, TaskRouterImpl);
        await taskRouter.init();
        const logger = getLogger(context)(LoggerName.Actions);
        const analytics = context.retrieveInstanceOf(ContextInstance.AnalyticsImpl, AnalyticsImpl);
        const cbm = context.retrieveInstanceOf(ContextInstance.CbmImpl, CbmImpl);
        await cbm.init();

        logger.debug(`completeTask invoked with taskSid: ${this.#taskSid}`);

        const worker = taskRouter.worker;

        if (!worker) {
            const errorMsg = "completeTask: worker is not initialized";
            logger.error(errorMsg);
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }

        const reservations = getReservationsByTask(worker, this.#taskSid).filter(
            (res) => res.status === "wrapping" || res.status === "accepted"
        );

        if (!reservations.length) {
            const errorMsg = `completeTask: Reservation for task ${this.#taskSid} not found`;
            logger.error(errorMsg);
            sendTrackingEvent(EVENTS.CompleteTaskCompleted, analytics, worker, {
                error: errorMsg,
                taskSid: this.#taskSid
            });
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }

        try {
            await Promise.all(reservations.map((reservation) => cbm.completeReservation(reservation)));
            sendTrackingEvent(EVENTS.CompleteTaskCompleted, analytics, worker, {
                taskSid: this.#taskSid,
                reservationSids: reservations.map((res) => res.sid)
            });
        } catch (error) {
            const errorMsg = `completeTask: Failed to complete reservation`;
            logger.error(errorMsg);
            sendTrackingEvent(EVENTS.CompleteTaskCompleted, analytics, worker, {
                error: errorMsg,
                taskSid: this.#taskSid,
                reservationSids: reservations.map((res) => res.sid)
            });
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }

        return reservations[0].task;
    }
}
